// DeadLinks.jsx

import React, { useState } from 'react';

const DeadLinks = () => {
  const [deadLinks, setDeadLinks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [url, setUrl] = useState('');
  const [progress, setProgress] = useState(0);
  const [checkedPages, setCheckedPages] = useState([]);

  const fetchDeadLinks = async () => {
    setLoading(true);
    setError(null);
    setProgress(0);

    try {
      const response = await fetch(`/wp-json/deadlinks/v1/get_dead_links?url=${encodeURIComponent(url)}`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setDeadLinks(data.dead_links);
      setCheckedPages(data.checked_pages);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchDeadLinks();
  };

  return (
    <div>
      <h2>Dead Links Check</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="Voer een URL in om te controleren"
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? 'Bezig met laden...' : 'Check Dead Links'}
        </button>
      </form>
      {loading && <p>Bezig met controleren van links... Voortgang: {progress}%</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {deadLinks.length > 0 ? (
        <div>
          <h3>Gebroken Links</h3>
          <table>
            <thead>
              <tr>
                <th>Link</th>
                <th>Status</th>
                <th>Pagina/Post</th>
              </tr>
            </thead>
            <tbody>
              {deadLinks.map((link, index) => (
                <tr key={index}>
                  <td>{link.url}</td>
                  <td>{link.status}</td>
                  <td>{link.page}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>Geen gebroken links gevonden.</p>
      )}
      {checkedPages.length > 0 && (
        <div>
          <h3>Gecontroleerde Pagina's</h3>
          <ul>
            {checkedPages.map((page, index) => (
              <li key={index}>{page}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default DeadLinks;
